import { getSissiEncoreUrl } from "../../config/server";

async function getContacts(params = {}) {
  params = {
    ...params,
    q: params.name || params.filter,
    skip: params.skip || 0,
    limit: params.limit || 50,
  };
  if (!params.q) {
    delete params.q;
  }

  const urlSearchParams = new URLSearchParams(params);
  const url = new URL(`${getSissiEncoreUrl()}/contacts`);
  url.search = urlSearchParams.toString();

  const res = await fetch(decodeURIComponent(url.toString()), {
    credentials: "include",
    mode: "cors",
  });

  if (res.status !== 200) {
    throw await res.json();
  }
  return await res.json();
}

function getContact(contactId) {
  const url = new URL(`${getSissiEncoreUrl()}/contacts/${contactId}`);
  return fetch(decodeURIComponent(url.toString()), {
    credentials: "include",
    mode: "cors",
  })
    .then((res) => (res.ok ? res.json() : null))
    .catch(() => null);
}

async function saveContact(contactData) {
  const url = `${getSissiEncoreUrl()}/contacts`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(contactData),
  });

  if (!response.ok) {
    const errorBody = await response.json();
    throw new Error(
      `Error al guardar: ${response.statusText} - ${errorBody.message || ""}`,
    );
  }
  return response.json();
}

async function updateContact(contactData) {
  const url = `${getSissiEncoreUrl()}/contacts/${contactData.id}`;

  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(contactData),
  });

  if (!response.ok) {
    const errorBody = await response.json();
    throw new Error(
      `Error al guardar: ${response.statusText} - ${errorBody.message || ""}`,
    );
  }
  return response.json();
}

async function getCompanies(params = {}) {
  params = {
    ...params,
    name: params.name || params.filter,
  };
  if (!params.name) {
    delete params.name;
  }
  const urlSearchParams = new URLSearchParams(params);
  const url = new URL(`${getSissiEncoreUrl()}/company/names`);
  url.search = urlSearchParams.toString();
  return fetch(decodeURIComponent(url.toString()), {
    credentials: "include",
    mode: "cors",
  })
    .then((res) => {
      return res.json();
    })
    .catch(() => []);
}

async function getTitles(params = {}) {
  params = {
    ...params,
    name: params.name || params.filter,
  };
  if (!params.name) {
    delete params.name;
  }
  const urlSearchParams = new URLSearchParams(params);
  const url = new URL(`${getSissiEncoreUrl()}/contact-title/names`);
  url.search = urlSearchParams.toString();
  return fetch(decodeURIComponent(url.toString()), {
    credentials: "include",
    mode: "cors",
  })
    .then((res) => {
      return res.json();
    })
    .catch(() => []);
}

async function getLanguages(params = {}) {
  params = {
    ...params,
    name: params.name || params.filter,
  };
  if (!params.name) {
    delete params.name;
  }
  const urlSearchParams = new URLSearchParams(params);
  const url = new URL(`${getSissiEncoreUrl()}/shared/languages`);
  url.search = urlSearchParams.toString();
  return fetch(decodeURIComponent(url.toString()), {
    credentials: "include",
    mode: "cors",
  })
    .then((res) => {
      return res.json();
    })
    .catch(() => []);
}

async function getTags(params = {}) {
  params = {
    ...params,
    name: params.name || params.filter,
  };
  if (!params.name) {
    delete params.name;
  }
  const urlSearchParams = new URLSearchParams(params);
  const url = new URL(`${getSissiEncoreUrl()}/shared/tags`);
  url.search = urlSearchParams.toString();
  return fetch(decodeURIComponent(url.toString()), {
    credentials: "include",
    mode: "cors",
  })
    .then((res) => {
      return res.json();
    })
    .catch(() => []);
}

async function getUsers(params = {}) {
  params = {
    ...params,
    name: params.name || params.filter,
  };
  if (!params.name) {
    delete params.name;
  }
  const urlSearchParams = new URLSearchParams(params);
  const url = new URL(`${getSissiEncoreUrl()}/shared/users`);
  url.search = urlSearchParams.toString();
  return fetch(decodeURIComponent(url.toString()), {
    credentials: "include",
    mode: "cors",
  })
    .then((res) => {
      return res.json();
    })
    .catch(() => []);
}

function mergeStatesIntoCountries(countries, states) {
  return countries.map((country) => ({
    ...country,
    states: states.filter((state) => state.countryId === country.id),
  }));
}

// Support endpoint for the contact form: loads the country and state/province
// catalogs and returns the countries with their states nested under `states`,
// which is the shape the address form and address card expect. Tolerates both
// the legacy `{countries}`/`{states}` envelopes and bare-array responses.
async function getCountries() {
  const countriesUrl = new URL(`${getSissiEncoreUrl()}/shared/countries`);
  const statesUrl = new URL(`${getSissiEncoreUrl()}/shared/states`);
  try {
    const [countriesRes, statesRes] = await Promise.all([
      fetch(decodeURIComponent(countriesUrl.toString()), {
        credentials: "include",
        mode: "cors",
      }),
      fetch(decodeURIComponent(statesUrl.toString()), {
        credentials: "include",
        mode: "cors",
      }),
    ]);
    const countriesBody = await countriesRes.json();
    const statesBody = await statesRes.json();
    const countries = Array.isArray(countriesBody)
      ? countriesBody
      : (countriesBody?.countries ?? []);
    const states = Array.isArray(statesBody)
      ? statesBody
      : (statesBody?.states ?? []);
    return mergeStatesIntoCountries(countries, states);
  } catch (e) {
    return [];
  }
}

export {
  getCompanies,
  getContact,
  getContacts,
  getCountries,
  getLanguages,
  getTags,
  getTitles,
  getUsers,
  saveContact,
  updateContact,
};
